import { useState, useEffect } from 'react';
import { ThemeContext } from './theme-context';
export function ThemeProvider({ children }) {
    const [isDark, setIsDark] = useState(() => {
        const saved = localStorage.getItem('theme');
        return saved === 'dark';
    });
    useEffect(() => {
        localStorage.setItem('theme', isDark ? 'dark' : 'light');
        if (isDark) {
            document.documentElement.classList.add('dark');
        }
        else {
            document.documentElement.classList.remove('dark');
        }
    }, [isDark]);
    const toggleTheme = () => setIsDark(!isDark);
    return (<ThemeContext.Provider value={{ isDark, toggleTheme }}>
      <div className={`sp-portal${isDark ? ' sp-theme-dark' : ''}`}>{children}</div>
    </ThemeContext.Provider>);
}
